/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

export const FETCH_COLLECTION_SUCCESS = 'FETCH_COLLECTION_SUCCESS';

export function fetchCollectionSuccess(payload) {
    return {type: FETCH_COLLECTION_SUCCESS, payload: payload};
}

export const CLEAR_COLLECTION = 'CLEAR_COLLECTION';

export function clearCollection(payload) {
    return {type: CLEAR_COLLECTION};
}
export const CHANGE_COLLECTION_TITLE = 'CHANGE_COLLECTION_TITLE';

export function changeCollecitonTitle(title) {
    return {type: CHANGE_COLLECTION_TITLE, title: title};
}

export const CHANGE_COLLECTION_TRIMSIZE = 'CHANGE_COLLECTION_TRIMSIZE';

export function changeCollecitonTrimSize(trimSize) {
    return {type: CHANGE_COLLECTION_TRIMSIZE, trimSize: trimSize};
}

export const GET_BOOK_BUILD_STATUS = 'GET_BOOK_BUILD_STATUS';

export function getBookBuildStatus(payload) {
    return {type: GET_BOOK_BUILD_STATUS, payload: payload};
}

export const CLEAR_BOOK_BUILD_STATUS = 'CLEAR_BOOK_BUILD_STATUS';

export function clearBookBuildStatus() {
    return {type: CLEAR_BOOK_BUILD_STATUS};
}

export const SET_PRIVATE_RESOURCE_STATUS = 'SET_PRIVATE_RESOURCE_STATUS';

export function setResourceStatus(payload) {
    return {type: SET_PRIVATE_RESOURCE_STATUS, payload: payload};
}



// WEBPACK FOOTER //
// ./src/_actions/collection.actions.js